export default "__VITE_ASSET__CbnLjkVe__"